module.exports = __webpack_public_path__ + "src/assets/img/share/level2/9e409eb533d9ef5f787223ad29f18ad1.png";